import { useCallback, useMemo, useState } from 'react';
import { filterBy } from 'new/utils/filterBy';

export function useFilteredData(data: any[], ...fields: string[]) {
  const [search, setSearch] = useState('');

  const onSearchChange = useCallback((event) => {
    setSearch(event.target.value);
  }, []);

  return useMemo(() => {
    const filteredData = data.filter(filterBy(search, ...fields));
    return { onSearchChange, filteredData };
  }, [search, data, ...fields]);
}
